var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 2.66667C23.352 2.66667 29.3333 8.648 29.3333 16C29.3333 23.352 23.352 29.3333 16 29.3333C8.648 29.3333 2.66667 23.352 2.66667 16C2.66667 8.648 8.648 2.66667 16 2.66667ZM16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM22 23.0813L19.6533 18.552L18.2773 19.2253C16.784 19.9493 13.744 14.012 15.204 13.2293L16.5933 12.5453L14.264 8L12.86 8.69333C8.05867 11.196 15.6827 26.0147 20.5933 23.7707L22 23.0813Z","fill":"#4693FF"}));
}

Phone.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
